import React, { useContext } from 'react'
import dynamic from 'next/dynamic'
import { pathOr } from 'ramda'
import { AceContentProvider } from '@pcln/ace-content-react'
import { Box } from 'pcln-design-system'
import BootstrapDataContext from '../../context/BootstrapDataContext'

const HomeDesktop = dynamic(() => import('./HomeDesktop'))
const HomeMobile = dynamic(() => import('./HomeMobile'))

export default function Home() {
  const { aceContent = {}, isMobile = false } = useContext(BootstrapDataContext)
  const HOMEPAGE = pathOr({}, ['contentValues', 'HOMEPAGE'], aceContent)
  const VIPHOMEPAGE = pathOr({}, ['contentValues', 'VIPHOMEPAGE'], aceContent)
  const SHARED = pathOr({}, ['contentValues', 'SHARED'], aceContent)
  return (
    <AceContentProvider content={{ ...SHARED, ...HOMEPAGE, ...VIPHOMEPAGE }}>
      <Box>{isMobile ? <HomeMobile /> : <HomeDesktop />}</Box>
    </AceContentProvider>
  )
}
